import { render } from "./printTransferCode.vue?vue&type=template&id=fb3a17f6&scoped=true"
import script from "./printTransferCode.vue?vue&type=script&lang=js"
export * from "./printTransferCode.vue?vue&type=script&lang=js"

import "./printTransferCode.vue?vue&type=style&index=0&id=fb3a17f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fb3a17f6"

export default script